import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone:true,
  imports: [CommonModule ,RouterOutlet,MenuComponent,HeaderComponent,FooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  currentRoute: string = '';

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }

  isLoginPage(): boolean {
    // Adjust the route path to match your login route
    return this.currentRoute === '/login' || this.currentRoute === '/registration' || this.currentRoute ==='reset-password' ||/^\/registration-success\/[^/]+\/[^/]+$/.test(this.currentRoute) || /^\/vendor-evaluation\/[^/]+$/.test(this.currentRoute);
  }
}
